// Who may open the monthly fee review: a named list of PEOPLE, not roles.
//
// CONSUMER: both (the server gate in workers/api/src/routes/admin/
// fee-review.ts AND the UI predicate in web/src/utils/role-visibility.ts
// import THIS module, so nav and server can never disagree about who's in).
//
// Grant's call, 2026-09-01: "just me, Baker, and Jake."
//
// DECISION (2026-10-31, after an outside UX audit opened the page as a
// QA system_admin account): the gate used to admit every system_admin and
// every compliance account with financial-or-all scope, on the reasoning
// that those roles WERE Grant and Baker. They are not only Grant and Baker:
// any test, QA or future admin account inherits the role, and the role
// alone then opened a page Grant scoped to three people. So the gate is
// now people only, matched by sign-in email. Rejected: keeping the role
// path and excluding QA accounts by name (a deny list fails open the next
// time someone makes an admin account). Adding a person is a one-line
// change reviewed like any other access change.

export const FEE_REVIEW_ALLOWED_EMAILS: readonly string[] = [
  "grant@stewardship.pro",
  "baker@stewardship.pro",
  "jake@stewardship.pro",
];

/** True only for the named people. Case- and whitespace-insensitive. */
export function isFeeReviewPerson(email: string | null | undefined): boolean {
  const normalized = (email ?? "").trim().toLowerCase();
  return normalized !== "" && FEE_REVIEW_ALLOWED_EMAILS.includes(normalized);
}
